import { IShow } from '../interfaces/IShow';

export class ShowsUtils {

  public static updateShowVisibilityFlags(show: IShow): IShow {
    const now = Date.now();
    const { startSale, endSale, startReservation } = show.restrictions;

    return {
      ...show,
      sellable: now >= (new Date(startSale)).getTime(),
      reservable: now >= (new Date(startReservation)).getTime(),
      isPast: now > (new Date(endSale)).getTime()
    };
  }
}
